import { render, staticRenderFns } from "./WithdrawalRequestCard.vue?vue&type=template&id=89cec74e"
import script from "./WithdrawalRequestCard.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequestCard.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRequestCard.vue?vue&type=style&index=0&id=89cec74e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports